/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";
import { Animated } from "react-animated-css";

/* Helpers, constants, custom methods, internal libraries */
import { usePeopleService } from "../../../services/peopleService.js";
import { nameInitials } from "../../../helpers/general.js";

/* Components */
import UCAutocomplete from "../../ucautocomplete/index.js";
import { ReactComponent as CloseButton } from "../../../resources/images/close-icon.svg"

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../constants/colors";

const messages = defineMessages({
  mailEmailPlaceholder: {
    id: "travelCredits.assign.modal.nameOrEmail",
  },
});

const Content = props => {
  const { setShowTravelCreditsAssignModal, showTravelCreditsAssignModal, assignCreditsStep, handleContinue, userDetails, removableChip, setRemovableChip} = props;

  const { searchPeople } = usePeopleService();

  const intl = useIntl();
  const theme = useTheme();
  const classes = styles({ theme });
  const [options, setOptions] = useState(null);

  useEffect(() => {
    if (!showTravelCreditsAssignModal) {
      setRemovableChip({})
    }
  }, [showTravelCreditsAssignModal])

  const getOptions = async (term) => {
    //const groupEntityId = userDetails?.userInfo?.companyInfo?.GroupEntityId
    const response = await searchPeople(term, 'ACTIVE');
    if (term.length < 3) {
      setOptions(null);
    } else {
      setOptions(response);
    }
  };

  const handleRemoveSelectedUser = () => {
    setRemovableChip({})
    setOptions(null)
  }

  return (
      <div className={classes.modalContent}>
          {assignCreditsStep === 0 ? (
            <>
            <div className={classes.dividerContainer}>
               <hr className={classes.border}/>
            </div>
            <p className={classes.assignTo}><FormattedMessage id="travelCredits.assign.modal.assignTo" /></p>
            {Object.values(removableChip).length > 0 ? (
              <div className={classes.selectedUser}>
                <div className={classes.userDetails}>
                  <div className={classes.profileAvatar}>
                    {
                      nameInitials(
                        `${removableChip.firstName} ${removableChip.lastName}`
                      )
                    }
                  </div>
                  <div className={classes.userDiv}>
                    <div className={classes.name}>
                      {`${removableChip.firstName} ${removableChip.lastName}`}
                    </div>
                    <div className={classes.email}>
                      {removableChip.emailAddress}
                    </div>
                  </div>
                </div>
                <UCButton
                  type='link'
                  className={classes.manageButton}
                  icon={<CloseButton />}
                  onClick={handleRemoveSelectedUser}
                />
              </div>
            ) : (
              <UCAutocomplete
                options={options}
                getOptions={getOptions}
                onSelectOption={() => {}}
                type={"PEOPLE_DETAILED"}
                placeholder={intl.formatMessage(messages.mailEmailPlaceholder)}
                inputWrapperStyling={classes.inputWrapperStyling}
                optionsStyling={classes.autocompleteOptions}
                removableChip={removableChip}
                setRemovableChip={setRemovableChip}
              />
            )}

            </>

          ) : (
            <Animated
              animationIn="fadeIn"
              animationOut="fadeOut"
              animationOutDuration={150}
              animationInDuration={150}
            >
              <div className={classes.details}><FormattedMessage id="travelCredits.assign.modal.confirm.assign.note" /> </div>
            </Animated>
          )}
        <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowTravelCreditsAssignModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="travelCredits.assign.modal.cancelBtn" />}
              />
            </Col>
            <Col className={classes.colContinue} >
              <UCButton
                className={classes.continueBtn}
                onClick={handleContinue}
                type="primary"
                disabled={Object.values(removableChip).length === 0}
                text={<FormattedMessage id="travelCredits.assign.modal.assignBtn" />}
                spinner={{
                  name: "travelCreditsAssignSpinner",
                  size: 20,
                  color: colors.white
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default Content;
